<tn-dialog-shell testId="subsystem-partially-created" [title]="'Saved Partially' | translate">
  <div class="title-icon">
    <tn-icon name="alert" library="mdi"></tn-icon>
  </div>

  <p>
    {{ 'Subsystem "{name}" has been created.' | translate: { name: data.subsystem.name } }}<br>
    {{ 'However, we could not create some related items:' | translate }}
  </p>

  <ul>
    @for (error of data.relatedErrors; track error) {
      <li>{{ error }}</li>
    }
  </ul>

  <p>
    {{ 'Please create related items manually.' | translate }}
  </p>

  <ix-form-actions tnDialogAction class="form-actions">
    <tn-button
      testId="close-partial-failure-dialog"
      [label]="'Close' | translate"
      (onClick)="dialogRef.close()"
    ></tn-button>
  </ix-form-actions>
</tn-dialog-shell>
